type Endpoints = {
  name: string;
  endpoint: string;
};

export type AmplifyConfigType = {
  aws_appsync_graphqlEndpoint: string;
  aws_appsync_region: string;
  API: {
    endpoints: [Endpoints];
  };
};

type SimplifiedConfig = {
  appSyncGraphqlEndpoint: string;
};

const expandConfig = (config: SimplifiedConfig): AmplifyConfigType => {
  return {
    aws_appsync_graphqlEndpoint: config.appSyncGraphqlEndpoint,
    aws_appsync_region: 'us-east-1',
    API: {
      endpoints: [
        {
          name: 'gql',
          endpoint: config.appSyncGraphqlEndpoint,
        },
      ],
    },
  };
};

const AmplifyConfigBranch: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint: 'http://localhost:4000/graphql',
});

const AmplifyConfigDev: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint: 'https://condor-api-dev.cs.dev.opetics.com/graphql',
});

const AmplifyConfigStaging: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint:
    'https://condor-api-staging.cs.dev.opetics.com/graphql',
});

const AmplifyConfigProd: AmplifyConfigType = expandConfig({
  appSyncGraphqlEndpoint: 'https://condor-api.cs.prod.opetics.com/graphql',
});

export {
  AmplifyConfigStaging,
  AmplifyConfigDev,
  AmplifyConfigBranch,
  AmplifyConfigProd,
};
